var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoTitheLyIconOnly = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5BD9A4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.084 15.676c2.12-.856 3.693-2.712 3.888-4.889l.021-.48c0-2.954-1.511-5.566-3.866-7.307-2.355 1.741-3.953 4.368-3.953 7.322l.022.481c.195 2.177 1.768 4.017 3.888 4.873zM14.096 19.11c-.117-.457-.304-.859-.507-1.275a6.929 6.929 0 0 0-1.972-2.419c-1.218-.965-2.8-1.5-4.356-1.5H3c.008.533 0 1.066 0 1.6.045.935.278 1.854.689 2.698a6.964 6.964 0 0 0 1.973 2.421c1.199.95 2.733 1.555 4.275 1.555h4.248c0-1.15.054-2.525-.089-3.08zM16.401 17.835c-.203.416-.39.818-.507 1.274-.113.436-.104 1.376-.094 2.316.002.259.005.517.005.765h-.01v1.463L15.617 28h.8l.028-.424c.08-1.212.168-2.538.327-3.625.178-1.215 1.522-1.74 2.488-1.76h.797c1.543 0 3.079-.605 4.279-1.556a6.966 6.966 0 0 0 1.974-2.42 6.91 6.91 0 0 0 .69-2.7c0-.177 0-.355-.002-.533-.001-.355-.003-.711.002-1.066h-4.265c-1.557 0-3.14.535-4.36 1.5a6.93 6.93 0 0 0-1.974 2.419z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoTitheLyIconOnly);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-tithe-ly-icon-only.d9bf3a17135932f8860f2a54f3e8e424.svg";